import type { StickyBannerSlide } from "../_components/sticky-banner/sticky-banner";

export const homeStickyBannerSlides: StickyBannerSlide[] = [
  {
    id: "quiz",
    mobile: {
      background: "var(--color-base-13)",
      layout: "split",
      content: {
        type: "quiz",
        items: {
          logo: "hormone-graphs",
          text: "Not sure if Inito will work for you?",
          modalId: "quiz",
        },
        cta: {
          text: "Take Quiz",
          icon: "arrow-small",
        },
      },
    },
    desktop: {
      background: "var(--color-base-12)",
      showDesktopTexture: true,
      layout: "center",
      content: {
        type: "quiz",
        items: {
          logo: "hormone-graphs",
          text: "Not sure if Inito will work for you?",
          modalId: "quiz",
        },
        cta: {
          text: "Start Quiz",
          icon: "chevron",
        },
      },
    },
  },
  {
    id: "benefits",
    mobile: {
      background: "var(--color-base-13)",
      layout: "center",
      content: {
        type: "benefits",
        items: [
          { icon: "eligible", text: "HSA/FSA eligible" },
          { icon: "shipping", text: "Free US Shipping" },
        ],
      },
    },
    desktop: {
      background: "var(--color-base-12)",
      showDesktopTexture: true,
      layout: "center",
      content: {
        type: "benefits",
        items: [
          { icon: "eligible", text: "HSA/FSA eligible" },
          { icon: "shipping", text: "Free US Shipping" },
        ],
      },
    },
  },
];
